import { PrivateRoot } from './PrivateRoot';

export default PrivateRoot;
